// Mobile runtime controls must never become implicit web feature flags.
export function toWebPlatformConfiguration(configuration) {
  if (!configuration || typeof configuration !== "object") return configuration ?? null;
  const { mobile: _mobileOnly, ...webConfiguration } = configuration;
  return webConfiguration;
}
